import React from "react";
import "./index.css";

const acceptForPropName = (propName) => {
    if (propName === "cv") return ".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    return ".pdf,.doc,.docx,.jpg,.jpeg,.png,.heic,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,image/png,image/heic";
};

export default ({ title, upload, propName, loading, multiple }) => {

    if (loading) {
        return(
            <div className="upload-document-disabled-button">
                <p className="upload-document-disabled-button-p">{title}</p>
            </div>
        );
    } else {
        return(
            <label className="upload-document-button">
                <input hidden={true} type={"file"} name={"file"} accept={acceptForPropName(propName)} onChange={(e) => upload(e.target.files, propName)} multiple={multiple} />
                <p className="upload-document-button-p">{title}</p>
            </label>
        );
    }

}